/** Default label for cart handling-fee lines (null / missing set_id). */
export const HANDLING_FEE_LABEL = 'Handling, Packaging & Transport';

type OrderItemLike = {
  set_id?: number | null;
  tool_id?: number | null;
  set_name?: string | null;
  tool_name?: string | null;
  name?: string | null;
  description?: string | null;
  article_no?: string | null;
};

function isToolItem(item: OrderItemLike): boolean {
  return item.tool_id != null && Number(item.tool_id) > 0;
}

function isHandlingFeeItem(item: OrderItemLike): boolean {
  if (isToolItem(item)) return false;
  if (item.set_id == null || item.set_id === undefined) return true;
  // Legacy cart used set_id -1 for handling before FK-safe null
  if (Number(item.set_id) < 0) return true;
  return false;
}

/** Human-readable line label for invoices / order details. */
export function orderItemDisplayName(item: OrderItemLike | null | undefined): string {
  if (!item) return HANDLING_FEE_LABEL;
  const named = (item.description || item.tool_name || item.set_name || item.name || '').trim();
  if (isHandlingFeeItem(item)) {
    if (!named || /^set\s*#?\s*null$/i.test(named) || /^set\s*#?\s*undefined$/i.test(named)) {
      return HANDLING_FEE_LABEL;
    }
    return named;
  }
  if (named && !/^set\s*#?\s*null$/i.test(named)) return named;
  if (isToolItem(item)) return `Tool #${item.tool_id}`;
  return `Set #${item.set_id}`;
}

/** Invoice line: "MS-000001 — Music Box" when article_no is present. */
export function orderItemInvoiceDescription(item: OrderItemLike | null | undefined): string {
  const name = orderItemDisplayName(item);
  if (!item || isHandlingFeeItem(item)) return name;
  const article = String(item.article_no || '').trim();
  if (article) return `${article} — ${name}`;
  return name;
}
